/**
 * Derive the initial modal state from a viewToolbar.
 * Pure — no React, no Redux. Kept small for unit testing.
 *
 * Priority order (from spec § "Mode resolution on open"):
 *  1. background URL (http:|https:|data:)           → Custom / Image
 *  2. themeId set, non-empty, not "custom"          → preset theme
 *  3. themeHtml non-empty                            → Custom / HTML
 *  4. background color (rgb/rgba/#hex)               → Custom / Color
 *  5. everything else                                → Custom / Color (default white)
 */
export const CUSTOM_THEME_ID = "custom";
export const DEFAULT_BACKGROUND_COLOR = "#ffffff";

const URL_RE = /^(https?:|data:)/i;
const COLOR_RE = /^(rgb[a]?\(|#)/i;

export function resolveCustomModeFromToolbar(toolbar) {
  const t = toolbar || {};
  const bg = typeof t.background === "string" ? t.background : "";
  const themeId = typeof t.themeId === "string" ? t.themeId : "";
  const themeHtml = typeof t.themeHtml === "string" ? t.themeHtml : "";

  const common = {
    imageUrl: URL_RE.test(bg) ? bg : "",
    backgroundAttr: t.backgroundAttr || "full",
    backgroundZoom: t.backgroundZoom != null ? Number(t.backgroundZoom) : 100,
    backgroundOpacity: t.backgroundOpacity != null ? Number(t.backgroundOpacity) : 100,
    html: themeHtml,
    color: COLOR_RE.test(bg) ? bg : DEFAULT_BACKGROUND_COLOR,
  };

  // 1. Image URL wins
  if (URL_RE.test(bg)) {
    return { themeIdForSelect: CUSTOM_THEME_ID, mode: "image", ...common };
  }

  // 2. Preset theme
  if (themeId && themeId !== CUSTOM_THEME_ID) {
    return { themeIdForSelect: themeId, mode: null, ...common };
  }

  // 3. themeHtml
  if (themeHtml.trim() !== "") {
    return { themeIdForSelect: CUSTOM_THEME_ID, mode: "html", ...common };
  }

  // 4 & 5. Color fallback
  return { themeIdForSelect: CUSTOM_THEME_ID, mode: "color", ...common };
}
